import { StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import { HeadingType } from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import { TagType } from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import HighlightCard from 'components/HighlightCard';
import PromotionalSlider from 'components/slider/PromotionalSlider';

interface HighlightProps {
    heading: HeadingType;
    id?: string;
    items: any[];
    sbEditable?: StoryblokEditable;
    slidesPerView?: { number: number; null: number }[];
    tag?: TagType;
    type: string;
}

const Highlight = ({ heading, id, items = [], sbEditable, slidesPerView, tag, type }: HighlightProps) => {
    const displaySlider = items.length > 5;

    return (
        <div {...sbEditable} className="highlight-module">
            <PromotionalSlider
                isDraggable
                type={type}
                isInfinite={false}
                $paginationStyle={{
                    display: displaySlider ? ['none', null, null, null, 'initial'] : 'none',
                }}
                headingFontKeys={['Primary/24_94_-1_700', 'Primary/32_94_-2_700']}
                id={id}
                heading={heading}
                slidesPerView={slidesPerView}
                snapAlign="none"
                spaceBetween="var(--margin-content)"
                tag={tag}
            >
                {items.map(({ uid, background, label, link }) => (
                    <HighlightCard background={background} key={uid} label={label} link={link?.url} />
                ))}
            </PromotionalSlider>
        </div>
    );
};

export default Highlight;
